import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Product } from '@utils/product';
import Image from '../../base_image/component';
import Link from '../../base_link/component';
import { ProductImage } from 'audamatic-ui';

import './styles/styles.scss';


class BannerDisplay extends Component {
  constructor(props) {
    super(props);

    this.product = {};

    if (Array.isArray(props.products)) {
      this.setProduct(props.products[0]);
    }
    this.pushGoogleTags = this.pushGoogleTags.bind(this);
  }

  setProduct(attrs) {
    if (typeof(attrs) === 'object' && attrs) {
      this.product = new Product(attrs);
    }
  }

  get hasButton() {
    const { url, buttonText } = this.props;
    return (url && buttonText);
  }

  get promotionTagData() {
    const { title, subtitle, variant } = this.props;
    return {
      title,
      name: subtitle,
      'component-type': this.props['component-type'],
      variant,
      url: this.url,
      ...this.images,
    };
  }

  pushGoogleTags() {
    this.props.googleTagMethods()
      .pushPromotionGoogleTag(this.promotionTagData);
  }

  renderOverlay() {
    const { rightImage, title } = this.props;
    if (rightImage) {
      return (
        <div className="overlay">
          <Image src={rightImage} alt={title} />
        </div>
      );
    }
  }

  renderImage() {
    const { title, leftImage } = this.props;
    if (this.product.image) {
      return (
        <div className="product-image-wrapper">
          <ProductImage product={this.product} />
        </div>
      );
    }
    if (leftImage) {
      return (
        <div className="front-image">
          <Image src={leftImage} alt={title} />
        </div>
      );
    }
    return '';
  }

  render() {
    const { title, subtitle, url, buttonText, newPrice, colorCode = '#f2f2f2', backgroundImage } = this.props;

    return (
      <Link href={url}
        className="banner-display"
        onClick={this.pushGoogleTags}
        style={{ backgroundColor: colorCode }}>

        <div className={`banner-media ${this.hasButton && 'extra-padding' }`} >
          <div className="img-container">
            <Image src={backgroundImage} alt={title} />
          </div>
          {this.renderImage()}
          {this.renderOverlay()}
          {this.hasButton &&
            <span className="btn btn-primary">{buttonText}</span>
          }
        </div>
        <div className="banner-body">
          {title &&
            <p className="h4 title">
              {title}
            </p>
          }
          {subtitle &&
          <p className="subtitle">
            {subtitle }
          </p>
          }
          {newPrice &&
          <p className="price">
            {newPrice}
          </p>
          }
        </div>
      </Link>
    );
  }
}


BannerDisplay.propTypes = {
  products: PropTypes.array,
  url: PropTypes.string,
  buttonText: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  colorCode: PropTypes.string,
  leftImage: PropTypes.string,
  rightImage: PropTypes.string,
  backgroundImage: PropTypes.string,
  variant: PropTypes.string,
  newPrice: PropTypes.string,
  googleTagMethods: PropTypes.func,
  'component-type': PropTypes.string,
  'image-shadow': PropTypes.string,
};


export default BannerDisplay;
